// import { YearEndReportComponent } from './management/reporting/sales-analysis-report/year-end-report/year-end-report.component';
// import { MonthEndReportComponent } from './management/reporting/sales-analysis-report/month-end-report/month-end-report.component';
// import { BestSellerReportComponent } from './management/reporting/sales-analysis-report/best-seller-report/best-seller-report.component';
// import { ItemShiftReportComponent } from './management/reporting/sales-report/item-shift-report/item-shift-report.component';
// import { SalesRemarkReportComponent } from './management/reporting/sales-report/sales-remark-report/sales-remark-report.component';
// import { PaymentComponent } from './management/pos/payment/payment.component';
// import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
// import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
// import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
// import { MatTabsModule } from '@angular/material/tabs';
// import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
// import { MatLegacyAutocompleteModule as MatAutocompleteModule} from '@angular/material/legacy-autocomplete';
// import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
// import { AngularEditorModule } from '@kolkov/angular-editor';
// import { NgxChartsModule } from '@swimlane/ngx-charts';
// import { MatStepperModule } from '@angular/material/stepper';
// import { TabViewModule } from "primeng/tabview";
// import { Setting2Component } from './management/settings/setting2/setting2.component';
// import { ReportsComponent } from './management/reports/reports.component';
// import { MessagesModule } from 'primeng/messages';
// import { MessageModule } from 'primeng/message';
// import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
// import {RatingModule} from 'primeng/rating';
// import {ProgressBarModule} from 'primeng/progressbar';
// import {CalendarModule} from 'primeng/calendar';
// import {SliderModule} from 'primeng/slider';
// import {MultiSelectModule} from 'primeng/multiselect';
// import {ContextMenuModule} from 'primeng/contextmenu';
// import { FileUploadModule } from 'primeng/fileupload';import { DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { LayoutModule } from '@angular/cdk/layout';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MAT_DATE_LOCALE, MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';

import { CookieService } from 'ngx-cookie-service';

import { ApiInterceptorInterceptor } from './interceptor/api-interceptor.interceptor';
import { WINDOW_PROVIDERS } from './window-provider';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import { LoginGuard } from './login.guard';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { OauthComponent } from './oauth/oauth.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SideNavMenuItemComponent } from './components/side-nav-menu-item/side-nav-menu-item.component';
import { ManagementComponent } from './management/management.component';
import { MainComponent } from './management/main/main.component';
import { FileComponent } from './management/file/file.component';
import { HelpComponent } from './management/help/help.component';
import { ConfirmDialogComponent } from './components/dialogs/confirm-dialog/confirm-dialog.component';
import { MessageDialogComponent } from './components/dialogs/message-dialog/message-dialog.component';
// import { CompanyProfileComponent } from './management/company-profile/company-profile.component';
import { PageFooterComponent } from './components/page-footer/page-footer.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { RegisterComponent } from './register/register.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { InputDialogComponent } from './components/dialogs/input-dialog/input-dialog.component';
import { EreceiptComponent } from './ereceipt/ereceipt.component';
import { EreceiptDialogsComponent } from './components/dialogs/ereceipt-dialogs/ereceipt-dialogs.component';
import { UnauthorizedComponent } from './management/unauthorized/unauthorized.component';
import { DirectivesModule } from './services/directives/directives.module';
import { CustomPipeModule } from './services/pipe/custom-pipe.module';
import { AuthSubdomainComponent } from './auth-subdomain/auth-subdomain.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { FooterComponent } from './components/footer/footer.component';
import { SharedComponentsModule } from './components/shared-components.module';
import { AppSettingsService } from "src/app/services/app-settings/app-settings.service";
import { ScrollTopModule } from 'primeng/scrolltop';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import {PasswordModule} from 'primeng/password';
import {SidebarModule} from 'primeng/sidebar';
import { InlineSVGModule } from 'ng-inline-svg-2';

export function initApp(appSettings: AppSettingsService) {
  return () => appSettings.loadDefaultCurrency();
}

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        OauthComponent,
        ManagementComponent,
        NotFoundComponent,
        SideNavMenuItemComponent,
        FileComponent,
        MainComponent,
        HelpComponent,
        ConfirmDialogComponent,
        MessageDialogComponent,
        // CompanyProfileComponent,
        PageFooterComponent,
        DataTableComponent,
        OauthComponent,
        RegisterComponent,
        ForgotpasswordComponent,
        InputDialogComponent,
        EreceiptComponent,
        EreceiptDialogsComponent,
        UnauthorizedComponent,
        AuthSubdomainComponent,
        MaintenanceComponent,
        FooterComponent
    ],
    imports: [
        SidebarModule,
        PasswordModule,
        HttpClientModule,
        BrowserModule,
        AppRoutingModule,
        LayoutModule,
        FlexLayoutModule,
        // TabViewModule,
        // FormsModule,
        ReactiveFormsModule,
        // NgxChartsModule,
        BrowserAnimationsModule,
        MatCardModule,
        // MatFormFieldModule,
        // MatInputModule,
        MatIconModule,
        MatRadioModule,
        MatButtonModule,
        MatSidenavModule,
        MatToolbarModule,
        MatListModule,
        MatExpansionModule,
        MatMenuModule,
        // MatTabsModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRippleModule,
        MatTableModule,
        // MatSortModule,
        // MatPaginatorModule,
        MatDialogModule,
        MatCheckboxModule,
        MatSnackBarModule,
        // MatAutocompleteModule,
        MatGridListModule,
        // NgxMaterialTimepickerModule,
        // AngularEditorModule,
        // NgxChartsModule,
        // MatStepperModule,
        MatProgressSpinnerModule,
        TableModule,
        ToastModule,
        ToolbarModule,
        // FileUploadModule,
        ConfirmDialogModule,
        DialogModule,
        InputTextareaModule,
        RadioButtonModule,
        InputNumberModule,
        ButtonModule,
        DropdownModule,
        // ProgressBarModule,
        InputTextModule,
        // CalendarModule,
        // SliderModule,
        // MultiSelectModule,
        // ContextMenuModule,    
        // MessagesModule,
        // MessageModule,
        // SpreadSheetsModule,
        DividerModule,
        ChipModule,
        PaginatorModule,
        MatMomentDateModule,
        MatTooltipModule,
        DirectivesModule,
        CustomPipeModule,
        SharedComponentsModule,
        ScrollTopModule,
        SweetAlert2Module,
        InlineSVGModule.forRoot()
    ],
    providers: [
        AuthService,
        AuthGuard,
        LoginGuard,
        ConfirmationService,
        MessageService,
        CookieService,
        DatePipe,
        WINDOW_PROVIDERS,
        { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptorInterceptor, multi: true },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: APP_INITIALIZER, useFactory: initApp, deps: [AppSettingsService], multi: true },
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
